import { StyleSheet } from 'lib/paypalphrodite'
export default StyleSheet.create({
  wrapper: {
    textAlign: 'center',
    overflow: 'auto',
    marginTop: -50,
    '@media (max-width: 450px)': {
      marginTop: -60,
      overflow: 'unset',
      paddingBottom: 20,
    },
  },
  header: {
    margin: '0px 40px 0 40px',
    color: 'black',
    paddingBottom: 20,
    '@media (max-width: 450px)': {
      margin: '-5px 0',
    },
  },
  attribution: {
    display: 'inline-block',
    margin: '15px auto 0',
    '@media (max-width: 1024px)': {
      margin: '8px 0 8px',
    },
    '@media (max-width: 450px)': {
      margin: '-5px 0 10px',
      fontSize: 15,
    },
    fontSize: 18,
    color: '#687173',
  },
  cardGroupWrapper: {
    position: 'relative', // so the absolutely positioned cards within are positioned with respect to this
    margin: '20px auto 30px',
    left: -28,
    overflow: 'visible', // so cards animating in aren't cut off
    '@media (max-width: 1024px)': {
      float: 'none',
      margin: 'auto',
    },
    '@media (max-width: 450px)': {
      float: 'none',
      margin: 0,
      width: 300,
      height: 375,
      left: 30,
    },
    height: 454,
    width: 320,
  },
  buttonEl: {
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 9,
    cursor: 'pointer',
    outline: 'none',
    transition: 'opacity 300ms ease',
    '@media (max-width: 1024px)': {
      margin: '10px 6px 10px',
    },
    '@media (max-width: 768px)': {
      margin: '10px 6px 10px',
    },
    ':hover': {
      transform: 'scale(1.1)',
    },
    ':focus': {
      outline: 'none',
    },
  },
  iconsWrapper: {
    display: 'flex',
    margin: '0 auto',
  },
  iconsWrapperBackground: {
    display: 'flex',
    width: '100%',
    backgroundColor: '#F5F7FA',
  },
  themeIcon: {
    backgroundSize: '105%',
    boxShadow: '0px 2px 1px 0px rgba(0,0,0,0.20)',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '50%',
    border: 'none',
    width: 65,
    height: 65,
    '@media (max-width: 1024px)': {
      width: 48,
      height: 48,
    },
    '@media (max-width: 450px)': {
      width: 40,
      height: 40,
    },
    ':focus': {
      outline: 'none',
    },
  },
  themeIconSelected: {
    borderRadius: '60%',
    border: '2px solid #fffefe',
    boxShadow: '0px 0px 3px 2px rgba(0,0,0,0.5)',
  },
  messageBtn: {
    margin: '30px auto 0px',
    display: 'inline-block',
    width: 120,
    fontSize: 13,
    fontWeight: 500,
    padding: 5,
    ':hover': {
      textDecoration: 'none',
    },
    '@media (max-width: 1024px)': {
      margin: '70px auto 0px',
    },
    '@media (max-width: 450px)': {
      margin: '15px auto 0px',
    },
  },
  centerPiece: {
    // wraps both theme icons, cards, and flip button — necessary to center on card
    margin: '0 auto', // center the whole thing, then...
    overflow: 'visible',
    position: 'relative',
  },
  nextButton: {
    margin: '20px auto 0',
    display: 'block',
    width: 172,
    ':hover': {
      textDecoration: 'none',
    },
  },
  cancelButton: {
    display: 'block',
    width: 250,
    margin: '20px auto 0',
    color: '#0070ba',
    ':hover': {
      textDecoration: 'none',
    },
  },
})
